import React, { useState, useEffect } from 'react';
import { Logo } from './Logo';
import { Menu, X } from 'lucide-react';

export const Header = ({ currentLanguage, onLanguageChange, t }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: t.nav.services, section: 'services' },
    { label: t.nav.method, section: 'method' },
    { label: t.nav.contact, section: 'contact' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/98 backdrop-blur-sm shadow-sm py-4' : 'bg-white py-5'
      }`}
    >
      <div className="container mx-auto px-8 flex items-center justify-between max-w-7xl">
        <Logo size="default" />

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-12">
          {navItems.map((item) => (
            <button
              key={item.section}
              onClick={() => scrollToSection(item.section)}
              className="text-gray-600 hover:text-gray-900 font-light text-sm tracking-wide uppercase transition-colors"
            >
              {item.label}
            </button>
          ))}
          
          {/* Language Switcher */}
          <div className="flex items-center gap-2 border-l border-gray-300 pl-8">
            <button
              onClick={() => onLanguageChange('en')}
              className={`text-sm tracking-wide uppercase transition-colors ${
                currentLanguage === 'en' ? 'text-gray-900 font-medium' : 'text-gray-400 hover:text-gray-600 font-light'
              }`}
            >
              EN
            </button>
            <span className="text-gray-300">/</span>
            <button
              onClick={() => onLanguageChange('es')}
              className={`text-sm tracking-wide uppercase transition-colors ${
                currentLanguage === 'es' ? 'text-gray-900 font-medium' : 'text-gray-400 hover:text-gray-600 font-light'
              }`}
            >
              ES
            </button>
          </div>
          
          <button
            onClick={() => scrollToSection('contact')}
            className="border border-gray-300 hover:border-gray-900 text-gray-900 px-6 py-2 text-sm tracking-wide uppercase transition-colors"
          >
            {t.nav.consultation}
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden text-gray-900"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 py-6 px-8">
          <nav className="flex flex-col gap-6">
            {navItems.map((item) => (
              <button
                key={item.section}
                onClick={() => scrollToSection(item.section)}
                className="text-gray-600 hover:text-gray-900 font-light text-sm tracking-wide uppercase transition-colors text-left"
              >
                {item.label}
              </button>
            ))}
            
            {/* Mobile Language Switcher */}
            <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
              <button
                onClick={() => {
                  onLanguageChange('en');
                  setIsMobileMenuOpen(false);
                }}
                className={`text-sm tracking-wide uppercase transition-colors ${
                  currentLanguage === 'en' ? 'text-gray-900 font-medium' : 'text-gray-400 font-light'
                }`}
              >
                EN
              </button>
              <span className="text-gray-300">/</span>
              <button
                onClick={() => {
                  onLanguageChange('es');
                  setIsMobileMenuOpen(false);
                }}
                className={`text-sm tracking-wide uppercase transition-colors ${
                  currentLanguage === 'es' ? 'text-gray-900 font-medium' : 'text-gray-400 font-light'
                }`}
              >
                ES
              </button>
            </div>
            
            <button
              onClick={() => scrollToSection('contact')}
              className="border border-gray-300 hover:border-gray-900 text-gray-900 px-6 py-3 text-sm tracking-wide uppercase transition-colors text-center mt-4"
            >
              {t.nav.consultation}
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
